@if (car && carBodyStyleLoaded) {
  <mat-card appearance="outlined" class="mat-elevation-z6 mwg-chart-wrapper padding-16 box-shadow">
    <colimo-mwg-chart-list
      [showChartFilters]="showChartFilters"
      [showChartTable]="showChartTable"
      [selectedAngles]="selectedAngles"
      [activeComponents]="activeComponents"
      [chartFilters]="chartFilters"
    ></colimo-mwg-chart-list>
  </mat-card>
}
